/**
 * Event Registration Form Manager
 * Handles dynamic form interactions for event registration
 */
export class RegistrationFormManager {
    constructor() {
        this.htmxListenerBound = false;
        this.init();
    }

    /**
     * Initialize the registration form handlers
     */
    init() {
        this.initializePriceDisplay();
        this.initializeGuestToggle();
        
        // Re-initialize after HTMX swaps content
        if (!this.htmxListenerBound) {
            document.addEventListener('htmx:afterSwap', (event) => {
                if (this.isRegistrationForm(event.target)) {
                    // Reset initialization flags for new content
                    this.initializePriceDisplay();
                    this.initializeGuestToggle();
                }
            });
            this.htmxListenerBound = true;
        }
    }

    /**
     * Check if the swapped content contains the registration form
     */
    isRegistrationForm(target) {
        return target.id === 'registration-form-container' ||
               target.querySelector('#registration-form-container') ||
               target.querySelector('#registration-type-select');
    }

    /**
     * Initialize price display functionality
     */
    initializePriceDisplay() {
        const selectElement = document.getElementById('registration-type-select');
        if (!selectElement) {
            return;
        }

        // Check if already initialized to prevent duplicate listeners
        if (selectElement.dataset.initialized === 'true') {
            return;
        }

        selectElement.addEventListener('change', (e) => {
            const selectedOption = e.target.options[e.target.selectedIndex];
            const price = parseFloat(selectedOption.dataset.price || 0);
            const priceDisplay = document.getElementById('price-display');
            const priceAmount = document.getElementById('price-amount');
            
            if (priceDisplay && priceAmount) {
                if (price > 0) {
                    priceAmount.textContent = price.toFixed(2);
                    priceDisplay.style.display = 'block';
                } else {
                    priceDisplay.style.display = 'none';
                }
            }
        });

        // Mark as initialized
        selectElement.dataset.initialized = 'true';
    }

    /**
     * Initialize guest checkbox toggle
     */
    initializeGuestToggle() {
        const guestCheckbox = document.getElementById('guest-checkbox');
        const guestNameField = document.getElementById('guest-name-field');
        
        if (!guestCheckbox || !guestNameField) {
            return;
        }

        // Check if already initialized to prevent duplicate listeners
        if (guestCheckbox.dataset.initialized === 'true') {
            return;
        }

        guestCheckbox.addEventListener('change', (e) => {
            if (e.target.checked) {
                guestNameField.style.display = 'block';
            } else {
                guestNameField.style.display = 'none';
            }
        });

        // Mark as initialized
        guestCheckbox.dataset.initialized = 'true';
    }
}
